import React from "react";
import "./emptyboder.css";

export default function EmptyBorder() {
  return (
    <div className="grid-about-section">
      {/* LEFT CARD */}
      <div className="grid-item">
        <div className="standcard">
          <h2 className="stand-title top-left-heading">What We Stand For</h2>

          <div className="card-inner">
            <p className="stand-text">
At our core, we stand for trust, transparency, and long-term financial well-being. Every service we provide is guided by strong values and a genuine commitment to our clients’ future. We believe in honest advice, ethical practices, and solutions that truly benefit our customers .Your goals come before everything else. We listen, understand, and deliver personalized financial strategies. We educate and guide our clients to make confident decisions about insurance, investments, and wealth creation. From quick responses to continuous support, we strive to deliver exceptional service at every step. We build relationships that last a lifetime by being dependable, transparent, and consistent. We grow only when our clients grow — with accountability, care, and long-term vision.
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="grid-item big-image">
        <img src="/comapany.jpg" alt="Company Overview" />
      </div>
    </div>
  );
}
